// https://date-fns.org/docs/format
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";

export function formatDate(date, pattern = "MM/dd/yyyy") {
  try {
    return format(parseISO(date), pattern);
  } catch (e) {
    console.warn(e);
    return null;
  }
}

export const formatDateTime = (date) =>
  formatDate(date, "MM/dd/yyyy @ hh:mm aa");

export default {
  formatDate,
  formatDateTime,
};
